import { connect } from "react-redux";

import { AbsoluteModelPath } from "../../../../../../Common/ModelPath/ModelPath";
import { EvaluableProp, withEvaluators } from "../../../withEvaluators";
import { ViewModelSelect } from "../../../../Helpers/StateAccessors/ViewModelSelect";
import { FullFormState } from "../../../../Engine/Core/Store/FullFormState";
import { withResolvePaths } from "../../../withResolvePaths";
import { withViewModelSelect } from "../../../withViewModelSelect";

import { MultiRow } from "./MultiRow";

export interface MultiRowContainerProps {
    bindingPath: AbsoluteModelPath;
    maxOccurs?: EvaluableProp<number>;
    viewModelSelect: ViewModelSelect;
    processEvaluableProp: <T>(state: FullFormState, prop: EvaluableProp<T>) => T;
    optional: boolean;
    filteredUniqKey?: string;
}

const mapStateToProps = (state: FullFormState, ownProps: MultiRowContainerProps) => {
    const { maxOccurs, filteredUniqKey = "default", processEvaluableProp } = ownProps;
    if (maxOccurs != undefined) {
        const localMaxOccurs = processEvaluableProp(state, maxOccurs);
        return {
            maxOccurs: localMaxOccurs,
            isReadOnly: state.settings.isReadOnly,
            filteredUniqKey: filteredUniqKey,
        };
    }
    return {
        maxOccurs: undefined,
        isReadOnly: state.settings.isReadOnly,
        filteredUniqKey: filteredUniqKey,
    };
};

export const MultiRowContainer = withResolvePaths(
    withViewModelSelect(withEvaluators(connect(mapStateToProps)(MultiRow)))
);
